<template>
  <div class="part-five">
    <div class="title">
      <div style="font-size: 40px; color: #091221; font-weight: bold">
        企业应该如何选择技术公司做后端支持？
      </div>
      <div style="font-size: 24px; color:#404040; margin-top: 30px">
        提供全方位的技术保障让企业专注业务增长
      </div>
    </div>
    <div class="content-box">
      <div class="left">
        <div class="left-head">芸众信息科技</div>
        <div class="left-box-item" v-for="item in left_content" style="background-color: #F3FAFF;">
          <img :src="require('../assets/image_1/1191.png')" />
          <div>
            <div class="main-color fz-24 mb-30" style="font-weight: bold;">{{ item.title }} </div>
            <div style="line-height: 30px;color: #494949;font-size: 20px;">{{ item.desc }}</div>
          </div>
        </div>
      </div>
      <div class="content-box-pk">
        <img :src="require('../assets/image_1/272.png')" alt="">
        <div class="content-box-pk-item" v-for="(item, index) in centet_content" :class="{ 'h171': index == 0 }">
          <div class="content-box-pk-item-txt">{{ item }}</div>
        </div>
      </div>
      <div class="right">
        <div class="right-head">外包技术/营销公司</div>
        <div class="left-box-item" v-for="item in right_content" style="background-color:  #F9F9F9;">
          <img :src="require('../assets/image_1/213.png')" style="width: 21px;height: 21px;" />
          <div>
            <div class="main-color fz-24 mb-30" style="font-weight: bold;">{{ item.title }} </div>
            <div style="line-height: 30px;color: #494949;font-size: 20px;">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="part-five-content">
      <div class="content-left">
        <div :class="{ 'content-left-item': true, 'active': activeIndex == 0 }" @click="changeActive(0)">工厂规模化供应链解决方案</div>
        <div :class="{ 'content-left-item': true, 'active': activeIndex == 1 }" @click="changeActive(1)">课程类内容供应链解决方案</div>
        <div :class="{ 'content-left-item': true, 'active': activeIndex == 2 }" @click="changeActive(2)">聚合CPS供应链解决方案</div>
        <div :class="{ 'content-left-item': true, 'active': activeIndex == 3 }" @click="changeActive(3)">企业级福利供应链解决方案</div>
        <div :class="{ 'content-left-item': true, 'active': activeIndex == 4 }" @click="changeActive(4)">政企供销社供应链解决方案</div>
      </div>
      <div class="content-right">
        <div class="content-right-img">
          <img :src="currentIndex.img" alt="">
        </div>
        <div style="margin-top:24px;font-size:18px;color:#ffffff">{{ currentIndex.des }}</div>
        <div class="content-right-button" @click="openDialog">免费领取</div>
        <div class="content-right-list">
          <span style="font-size:16px;color:#ffffff">相关案例</span>
          <img :src="item" alt="" v-for="(item, index) in currentIndex.logoList" :key="index">
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      rightShowList: [
        {
          img: require('../assets/part-five-img1.png'),
          des: '整合自有货源线上管理，通过API、集采、一件代发等方式，实现一站式的平台化和数字化线上采购，降低渠道管理成本，提升采购，出货效率。',
          logoList: [require('../assets/part-five-logo1.png'), require('../assets/part-five-logo2.png'), require('../assets/part-five-logo3.png'), require('../assets/part-five-logo4.png'), require('../assets/part-five-logo5.png')]
        },
        {
          img: require('../assets/part-five-img2.png'),
          des: '将“高效的引流资源—课程+视频+图文+素材”，通过是数字化中台方式，实现一键矩阵式分发给终端销售平台，完成内容运营能力的无限复制。',
          logoList: [require('../assets/part-five-logo15.png')]
        },
        {
          img: require('../assets/part-five-img3.png'),
          des: '整合自有货源线上管理，通过API、集采、一件代发等方式，实现一站式的平台化和数字化线上采购，降低渠道管理成本，提升采购，出货效率。',
          logoList: [require('../assets/part-five-logo10.png'), require('../assets/part-five-logo11.png'), require('../assets/part-five-logo12.png'), require('../assets/part-five-logo13.png'), require('../assets/part-five-logo14.png')]
        },
        {
          img: require('../assets/part-five-img4.png'),
          des: '将传统的“人力单向决策，员工被动接受”的福利管理模式转变为“员工自主选择”的自由福利模式，实现员工福利发放与员工满意度之间的契合。',
          logoList: [require('../assets/part-five-logo1.png'), require('../assets/part-five-logo2.png'), require('../assets/part-five-logo3.png'), require('../assets/part-five-logo4.png'), require('../assets/part-five-logo5.png')]
        },
        {
          img: require('../assets/part-five-img5.png'),
          des: '搭建供销生态圈，加强收购资源整合管理能力，打通供销链路效率化，拓展销售渠道全网链路，助力终端销售营销运营能力，实现链路一体化，提高收益能效。',
          logoList: [require('../assets/part-five-logo15.png')]
        },
      ],
      currentIndex: {},
      left_content: [
        { title: "灵活扩展 ", desc: "采用多语言混合开发（PHP/Go/Java），模块化设计，各系统独立部署且无缝集成。" },
        { title: "全链路防护", desc: "从技术底层到市场业务全链路防护功能，电子合同/分账/税务，满足企业级分控需求。" },
        { title: "极速上线", desc: "自研DevOps平台，自动化部署测试，最快1天上线系统。" },
        { title: "自主可控", desc: "支持私有化部署，商城系统全开源交付，企业自主可控，安全保密。" },
        { title: "一个底层不断优化", desc: "一个底层框架每周定期优化，每月定期升级，后台一键更新。" }
      ],
      centet_content: ['技术架构', '安全合规', '交付效率', '交付模式', '持续服务'],
      right_content: [
        { title: "单一封闭 ", desc: "技术栈单一，系统耦合度高，扩展性差，业务升级时易遇瓶颈。" },
        { title: "基础防护", desc: "仅基础技术加密防护，缺乏市场业务合规安全策略。" },
        { title: "拖延风险", desc: "依赖人工手动部署，交付周期长，延期风险高。" },
        { title: "技术绑定", desc: "仅提供SaaS或闭源方案，技术绑定风险高，功能受限于厂商。" },
        { title: "多底层频繁更换", desc: "频繁更换底层框架，市场响应滞后，容易导致业务中断。" }
      ]
    };
  },

  methods: {
    changeActive(index) {
      this.activeIndex = index
      this.currentIndex = this.rightShowList[index]
    },
    openDialog() {
      this.$emit('openDialog')
    }
  },
  created() {
    this.currentIndex = this.rightShowList[this.activeIndex]
  },
  components: {},
};

</script>
<style scoped lang="scss">
.part-five {
  /* background-image: url('../assets/part-five-bg.png'); */
  /* height: 820px; */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 130px;

  .content-box-pk img {
    display: block;
  }

  .mb-30 {
    margin-bottom: 30px;
  }

  .left-box-item:last-child::after {
    background-color: #fff;
  }

  .content-box-pk-item:last-child::after {
    background-color: #fff;
  }

  .h171 {
    height: 171px !important;
  }

  .content-box-pk-item-txt {
    font-weight: bold;
    font-size: 24px;
    color: #007EFF;
  }

  .content-box-pk-item {
    width: 157px;
    height: 194px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      background-color: #404040;
      height: 1px;
      opacity: 0.5;
      left: 30px;
      right: 30px;
    }
  }

  .left-box-item {
    width: 522px;
    height: 194px;
    padding-top: 45px;
    padding-left: 40px;
    padding-right: 42px;
    display: flex;
    box-sizing: border-box;
    white-space: wrap;
    text-wrap: wrap;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      background-color: #404040;
      height: 1px;
      opacity: 0.5;
      left: 63px;
      right: 61px;
    }

    img {
      width: 28px;
      height: 21px;
      margin-right: 15px;
    }
  }

  .content-box {
    display: flex;
    justify-content: center;
    margin-top: 60px;
  }

  .right-head {
    width: 521px;
    height: 97px;
    background: #EBEBEB;
    border-radius: 0px 8px 0px 0px;
    font-weight: bold;
    font-size: 32px;
    color: #091221;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .left-head {
    width: 522px;
    height: 97px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 32px;
    color: #FFFFFF;
    background: linear-gradient( 90deg, #0E63FF 0%, #007EFF 100%);
    border-radius: 8px 0px 0px 0px;
  }

  .fz-24 {
    font-size: 24px;
  }
}

.title {
  /* margin-top: 100px; */
}

.part-five-content {
  margin-top: 50px;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
}

.content-left {
  background: rgba(0, 0, 0, 0.3);
  padding: 60px 0 0 0;
}

.content-left-item {
  padding: 25px 18px;
  font-size: 20px;
  color: #ffffff;
}

.active {
  background-color: #3E85FF;
}

.content-right {
  padding: 26px 26px 48px 33px;
  max-width: 840px;
  position: relative;
}

.content-right-button {
  padding: 10px 24px;
  color: #ffffff;
  font-size: 14px;
  background-color: #2A7EFB;
  width: 56px;
  border-radius: 4px;
  margin-top: 5px;
  position: absolute;
  right: 23px;
  cursor: pointer;
}

.content-right-button:hover {
  opacity: 0.7;
}

.content-right-list {
  margin-top: 100px;
  margin-left: 20px;
  display: flex;
  align-items: center;
  /* justify-content: space-around; */
}

.content-right-list img {
  margin-left: 20px;
}

.content-right-img {
  display: flex;
  justify-content: center;
  height: 270px;
}
</style>